import React, { useEffect } from "react";
import { useError } from "./ErrorContext.jsx";

import axiosInstance, {
  axiosInstancePayment,
  axiosInstancePaymentIframe,
  axiosInstanceAppToken,
  axiosLoginInstance,
  axiosRelayInstance,
  //  axiosRegisterInstance
} from "../../../../axios.js";

const AxiosInterceptorProvider = ({ children }) => {
  const { handleError } = useError();

  useEffect(() => {
    const instances = [
      axiosInstance,
      axiosInstancePayment,
      axiosInstancePaymentIframe,
      axiosInstanceAppToken,
      axiosLoginInstance,
      axiosRelayInstance,
    ];

    const interceptorIds = instances.map((instance) =>
      instance.interceptors.response.use(
        (response) => response,
        (error) => {
          handleError(error);
          return Promise.reject(error);
        },
      ),
    );

    return () => {
      instances.forEach((instance, index) => {
        instance.interceptors.response.eject(interceptorIds[index]);
      });
    };
  }, [handleError]);

  return children;
};

export default AxiosInterceptorProvider;
